import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import RepaymentList2SF from '../../../components/superUser/loan/repayment/RepaymentList2SF.js'
import RepaymentNavUI from './RepaymentNavUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import CollectionModalSF from '../../../components/superUser/loan/repayment/CollectionModalSF'
import LoanInterestModalSF from '../../../components/superUser/loan/repayment/LoanInterestModalSF.js'
import './RepaymentPage.css'

const RepaymentPage2UI = ({ context, errorList, account, loan, repaymentList, chargeAmountsList, totals, onRefreshClick,
  onDownloadClick, collectionSubmitted, onCollectionSubmitClick, onCollectionCancelClick, onLoanInterestClick, loanInterestMode,
  onLoanInterestCancel, onDeleteClick
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_rp_lst'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !repaymentList || !errorList || !account} dimension='w1600'
    loan={loan} page='repayments'
  >
    {
      (!loan || !repaymentList || !errorList || !account) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      account && loan && repaymentList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div>
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                {
                  context && context.permissions.includes('su_superuser') &&
                  <IconButtonUI icon='icon-trash-o' label='Delete Disbursement' onClick={onDeleteClick} />
                }
                <IconButtonUI icon='icon-download' onClick={onDownloadClick} />
                <span className='g_m_left_100 g_large'><b>Repayments</b></span>
              </span>
              <div className='g_m_top_50'>
                {loan && <RepaymentNavUI loan={loan} page='repayment_v2' />}
              </div>
            </div>
          }
          right={
            <Link onClick={onLoanInterestClick} to='#'>
              Download loan interest certificate
            </Link>
          }
        />

        {
          loan.loanType === 'inv_discount' &&
          <CardUI title='Receivable financing' className='g_m_top_100'>
            {
              loan.status === 'disbursed' &&
              <Link onClick={onCollectionSubmitClick} to='#'>
                Collection
              </Link>
            }
            <br />
            {
              loan.closedDateF &&
              <>Closed date: {loan.closedDateF}</>
            }
          </CardUI>
        }

        {/*
          (loan.status === 'disbursed' || loan.subStatus === 'repaid' || loan.subStatus === 'prepaid' || loan.subStatus === 'received' || loan.subStatus === 'defaulted') &&
          <RepaymentListSF context={context} account={account} loan={loan} onRefreshClick={onRefreshClick} />
        */}

        {
          account && loan && repaymentList &&
          <RepaymentList2SF context={context} account={account} loan={loan}
            repaymentList={repaymentList} chargeAmountsList={chargeAmountsList}
            totals={totals} onRefreshClick={onRefreshClick} />
        }
        
        {
          !loan.termSheet.amountF2 && !loan.sanction.amountF2 &&
          <div className='g_m_left_100'>No amortization or repayments yet</div>
        }
      </div>
    }

    <CollectionModalSF
      context={context} loan={loan}
      updateMode={collectionSubmitted}
      onCancelClick={onCollectionCancelClick}
      onRefreshClick={onRefreshClick}
    />
    {loanInterestMode && (
      <LoanInterestModalSF
        context={context}
        loan={loan}
        loanInterestMode={loanInterestMode}
        onLoanInterestCancel={onLoanInterestCancel}
        onRefreshClick={onRefreshClick}
      />
    )}
  </SuperUserLoanPageSF>

export default RepaymentPage2UI
